import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, BookOpen } from 'lucide-react';
import { articles } from '../../pages/InsightsPage';

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 }
};

const featured = articles.slice(0, 3);

const FeaturedInsightsSection = () => {
  return (
    <section className="py-20 md:py-28 bg-white" data-testid="featured-insights-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-12" {...fadeInUp}>
          <h2 className="text-2xl sm:text-3xl font-heading font-bold text-carbon tracking-tight">
            INSIGHTS
          </h2>
          <Link to="/insights" className="text-sm font-semibold text-carbon hover:text-golden transition-colors inline-flex items-center flex-shrink-0">
            View all insights <ArrowRight className="ml-2 w-4 h-4" />
          </Link>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {featured.map((a, i) => (
            <motion.div
              key={a.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
            >
              <Link to="/insights" className="block bg-gray-50 border border-gray-100 p-6 group hover-lift h-full">
                <div className="flex items-center justify-between mb-3">
                  <span className="bg-golden/15 text-carbon text-xs font-semibold px-3 py-1">{a.category}</span>
                  <span className="text-xs text-carbon/40">{a.readTime}</span>
                </div>
                <h3 className="text-base font-heading font-semibold text-carbon mb-2 group-hover:text-golden transition-colors">{a.title}</h3>
                <p className="text-sm text-carbon/60 leading-relaxed mb-4">{a.excerpt}</p>
                <span className="inline-flex items-center text-sm font-semibold text-carbon group-hover:text-golden transition-colors">
                  <BookOpen className="w-4 h-4 mr-2" /> Read article
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedInsightsSection;
